import moment from 'moment';

export function convertDateToTheFormatMMDDYYYY(
  date: string,
  dateFormatByCultureCode: string,
) {
  return dateFormatByCultureCode === 'DD/MM/YYYY'
    ? moment(date, dateFormatByCultureCode).format('MM/DD/YYYY')
    : date;
}
